theme.headerSticky = (function () {
  function ScrollSticky(e) {
    var headerStickyTarget = document.querySelector(".header__sticky");

    if (headerStickyTarget) {
      window.addEventListener("scroll", function () {
        if (window.scrollY > 0) {
          headerStickyTarget.classList.add("sticky");
        } else {
          headerStickyTarget.classList.remove("sticky");
        }
      });
    }
  }
  return ScrollSticky;
})();
